import { render, staticRenderFns } from "./Relationship.vue?vue&type=template&id=8f8d833e&"
import script from "./Relationship.vue?vue&type=script&lang=ts&"
export * from "./Relationship.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports